import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initPostHog, posthog } from '../../lib/posthog';

export function AnalyticsProvider({ children }) {
    const location = useLocation();

    // 1) ініціалізація PostHog
    useEffect(() => {
        initPostHog();
    }, []);

    // 2) pageview при зміні шляху / query
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (!location) return;
        if (typeof posthog.capture !== 'function') return;

        const url = window.location.origin + location.pathname + (location.search || '');
        const segment = location.pathname.split('/')[1] || '';
        let eventName = 'app_pageview';

        // if (['signup', 'login'].includes(segment)) {
        //     eventName = `app_pageview_${segment}`;
        // }

        posthog.capture(eventName, {
            $current_url: url,
            segment,
        });

    }, [location.pathname, location.search]);

    return <>{children}</>;
}
